// Generated by CoffeeScript 2.7.0
var LocalMaterial, file_item_comp, sidenav_label_comp;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import Sidenav from 'trunks/vue/admin/components/libs/sidenav.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

sidenav_label_comp = {
  props: {
    item: {
      type: Object
    }
  },
  template: `<div class="justify-between">
  <div class="text-ellipsis justify-box">
    <i :class="item.children || item.navs ? 'slp-chevron-light-down expander' : 'slp-empty'"></i>
    <div class="text text-ellipsis">{{ item.name }}</div>
    <slot :item="item" name="addition_actions"></slot>
  </div>
  <slot name="addition_right"></slot>
</div>`
};

file_item_comp = {
  components: {
    'popover': Popover
  },
  props: {
    item: {
      type: Object
    },
    selectMaterials: {
      type: Array
    },
    editable: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'Group'
    }
  },
  data: function() {
    return {
      itemName: '',
      hasPopoverOpened: false
    };
  },
  template: `<div class="file-wrapper" :class="{'folder': view == 'Folder'}">
  <template v-if="view == 'Group'">
    <div class="preview"
         :class="{ 'nopreview': !_materialUrl(item), 'loading': !item.id}"
         @click.prevent="toggleMaterial($event)">
      <img v-if='item.id && _materialUrl(item)' :src="_materialUrl(item)" width="100%" height="100%"/>
      <div class="file-badge content-centered">
        <div class="reload-action content-centered"  v-if="canReload(item)" @click="reloadAttachment">
          <i class="slp-refresh-circle"></i>
        </div>
        <div class="loading-action content-centered" v-if="item._uploadRequest || (!item._error_message && !item.id)">
          <i class="slp-loading spin"></i>
        </div>
      </div>
    </div>
    <div class="select-checkbox" v-if="item.id">
      <label class="select-label">
        <input type="checkbox" class="select-judge" hidden="true" :checked='_exist(item)'></input>
        <i class="slp-check-circle-o"></i>
      </label>
    </div>
    <div class="file-info" v-if="item.extension == 'video' && item.extra_info">
      <div class="text">{{ _duration(item) }}</div>
    </div>
  </template>
  <template v-if="view == 'Folder'">
    <div class="preview" @click="selectFolder">
      <div class="file-badge content-centered">
        <i class="slp-folder"></i>
      </div>
    </div>
  </template>
  <div class="file-label">
    <div class="process-bg" :style="{ width: item._progress * 100 + '%' }" v-if='item._progress'></div>
    <span class="text-ellipsis">{{ item.name }}</span>
    <div class="manage-actions content-centered" :class="{'active': hasPopoverOpened}" v-if="editable && item.id">
      <popover position="bottom center" :caret='true' type="select" size="default" @beforeOpen="beforeOpenFunc" @beforeClose="beforeCloseFunc" ref='popover_rename'>
        <i class="slp-pencil" slot="trigger"></i>
        <div class="popover-select-content" slot="content">
          <div class="popover-select-header justify-box force-no-wrap">
            <span>新的名称</span>
            <input class="popover-input" type='text' v-model.trim='itemName'/>
          </div>
          <div class="popover-select-footer">
            <div class="btn text-btn btn-default" @click="cancelClicked('rename')">取消</div>
            <div class="btn text-btn" @click='ensureRename'>确认</div>
          </div>
        </div>
      </popover>
      <popover position="bottom center" :caret='true' type="confirm" size="large" @beforeOpen="beforeOpenFunc" @beforeClose="beforeCloseFunc" ref='popover_update' v-if="view=='Group'">
        <i class="slp-sort-active-default" slot="trigger"></i>
        <div class="popover-confirm-content" slot="content">
          <div class="popover-confirm-title">替换素材</div>
          <div class="popover-confirm-body">替换素材是永久操作，无法撤销</div>
          <div class="popover-confirm-footer">
            <div class="btn btn-default btn-small" @click="cancelClicked('update')">取消</div>
            <label>
              <input type="file" @change="ensureUpdate" hidden="true" :accept="'image/*,video/*'"/>
              <button class="btn-danger btn-small">确定</button>
            </label>
          </div>
        </div>
      </popover>
      <popover position="bottom center" :caret='true' type="confirm" size="large" @beforeOpen="beforeOpenFunc" @beforeClose="beforeCloseFunc" ref='popover_delete'>
        <i class="slp-trash" slot="trigger"></i>
        <div class="popover-confirm-content" slot="content">
          <div class="popover-confirm-title">删除</div>
          <div class="popover-confirm-body" v-if="view == 'Group'">删除素材是永久操作，无法撤销</div>
          <div class="popover-confirm-body" v-if="view == 'Folder'">删除分类的同时会删除其中的分组和素材</div>
          <div class="popover-confirm-footer">
            <div class="btn btn-default btn-small" @click="cancelClicked('delete')">取消</div>
            <div class="btn btn-danger btn-small" @click='ensureDelete'>确认</div>
          </div>
        </div>
      </popover>
    </div>
  </div>
</div>`,
  methods: {
    _materialUrl: function(material) {
      var _t, ref, ref1;
      if (material.extension === 'image') {
        _t = new Date();
        return `/admin/material/files/${material.id}/download_url?variant=logo&&${_t}`;
      } else {
        return (ref = (ref1 = material.extra_info) != null ? ref1.video_cover : void 0) != null ? ref : false;
      }
    },
    canReload: function(material) {
      return material._error_message && (material.size <= material.limitSize) && !material.id;
    },
    reloadAttachment: function() {
      return this.$emit('reload');
    },
    toggleMaterial: function(event) {
      return this.$emit('toggleMaterial', event);
    },
    selectFolder: function() {
      return this.$emit('selectFolder', this.item);
    },
    _exist: function(material) {
      return _.some(this.selectMaterials, function(item) {
        return item.id === material.id;
      });
    },
    _duration: function(material) {
      var duration, ref;
      duration = (ref = material.extra_info) != null ? ref.duration : void 0;
      return (parseInt(duration || 0)).toTimeFormat();
    },
    ensureRename: function() {
      this.$refs['popover_rename'].togglePopover();
      if (this.item.name === this.itemName) {
        return;
      }
      return this.$emit('ensureRename', this.item, this.itemName);
    },
    ensureDelete: function() {
      this.$refs['popover_delete'].togglePopover();
      return this.$emit('ensureDelete', this.item);
    },
    ensureUpdate: function(event) {
      this.$refs['popover_update'].togglePopover();
      return this.$emit('ensureUpdate', this.item, event);
    },
    cancelClicked: function(name) {
      this.$refs[`popover_${name}`].togglePopover();
      return this.$emit('cancel');
    },
    beforeOpenFunc: function() {
      return this.hasPopoverOpened = true;
    },
    beforeCloseFunc: function() {
      return this.hasPopoverOpened = false;
    }
  }
};

export default LocalMaterial = Vue.extend({
  props: {
    selectMaterials: {
      type: Array
    },
    materialType: {
      type: String,
      default: 'image'
    },
    totalSize: {
      type: Number
    },
    editable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    typeList: {
      type: Array,
      default: function() {
        return [
          {
            value: 'material',
            text: '全部'
          },
          {
            value: 'image',
            text: '仅图片'
          },
          {
            value: 'video',
            text: '仅视频'
          }
        ];
      }
    }
  },
  components: {
    'sidenav': Sidenav,
    'sidenav-label': sidenav_label_comp,
    'file-item': file_item_comp,
    'paginator': Paginator,
    'dropdown-select': DropdownSelect,
    'popover': Popover
  },
  template: `<div class="material-local justify-box">
  <div class="material-local-left">
    <sidenav ref="sidenav"
             :navList="nav_folder"
             :currentGroup="currentGroup"
             :currentFolder="currentFolder"
             :view="view"
             :editable="editable"
             @selectGroup="selectGroupFunc">
      <template slot-scope="{ item }" slot='label_template'>
        <sidenav-label :item="item">
          <div class="addon-right force-no-wrap" v-if="!item.navs" slot="addition_right">{{ _childrenMaterialCounts(item) }}</div>
        </sidenav-label>
      </template>
    </sidenav>
  </div>
  <div class="material-lib-root content justify-box">
    <div class="lib-inner content">
      <div class="file-tools justify-between"">
        <template v-if="view == 'Group'">
          <div class="left justify-box" v-if="editable">
            <template v-if="selectMaterials.length">
              <label class="force-no-wrap checkbox-select">
                <input type="checkbox" @change="selectAll" hidden='true' :checked="selectMaterials == material_files">
                <i class="slp-square-o"></i>
                <span>全选</span>
              </label>
              <popover position="bottom left" :caret='true' type="select" size="default" ref="popover_moveto">
                <button class="btn-default outlined btn-small" slot="trigger">移动</button>
                <template slot="content">
                  <div class="popover-select-content">
                    <div class="popover-select-body">
                      <sidenav :navList="nav_folder"
                               :filter="currentGroup"
                               view="show"
                               @selectGroup="targetGroupFunc">
                        <template slot-scope="{ item }" slot='label_template'>
                          <sidenav-label :item="item">
                            <button class="icon-btn" v-if="item == targetGroup" slot="addition_right">
                              <i class="slp-check"></i>
                            </button>
                          </sidenav-label>
                        </template>
                      </sidenav>
                    </div>
                    <div class="popover-select-footer">
                      <div class="btn text-btn btn-default" @click="cancelClicked('moveto')">取消</div>
                      <div class="btn text-btn" @click='moveMaterials'>确认</div>
                    </div>
                  </div>
                </template>
              </popover>
              <popover position="bottom center" :caret='true' type="confirm" size="large" ref="popover_delete">
                <button class="btn-default outlined btn-small" slot="trigger">删除</button>
                <div class="popover-confirm-content" slot="content">
                  <div class="popover-confirm-title">删除素材</div>
                  <div class="popover-confirm-body">删除素材是永久操作，无法撤销</div>
                  <div class="popover-confirm-footer">
                    <div class="btn btn-default btn-small" @click="cancelClicked('delete')">取消</div>
                    <div class="btn btn-danger btn-small" @click='deleteSelected'>确认</div>
                  </div>
                </div>
              </popover>
            </template>
            <template v-if="!selectMaterials.length">
              <span class="title">{{ currentGroup.name }}</span>
              <dropdown-select :optionGroups="[{ options: typeList }]"
                               :initValue='typeList[0]'
                               @change="typeChanged">
                <template slot='value-template' slot-scope='{ option }'>
                  <span>{{ option.text }}</span>
                </template>
                <template slot='option-template' slot-scope='{ option }'>
                  <span>{{ option.text }}</span>
                </template>
              </dropdown-select>
            </template>
          </div>
          <label v-if="!editable || !selectMaterials.length">
            <input type="file" :multiple='multiple' @change="addMaterials" hidden="true" :accept="acceptType" :disabled="uploading"/>
            <div class="btn btn-default outlined" :disabled="uploading" :class="{ 'btn-small': editable }">本地上传</div>
          </label>
        </template>
        <template v-if="view == 'Folder'">
          <span class="title">{{ currentFolder.name }}</span>
          <button class="btn-default btn-small outlined" @click="addFolder">新建分类</button>
        </template>
      </div>
      <div class="files-content justify-between">
        <template v-if="view == 'Group'">
          <div class="material-files" v-if="material_files.length">
            <div class="file"
                 v-for="(material, index) in material_files"
                 :key="material.id">
              <file-item :item='material'
                         :selectMaterials="selectMaterials"
                         :editable="editable"
                         :view="view"
                         @reload="reloadAttachment(index)"
                         @toggleMaterial="toggleMaterial($event, material, index)"
                         @ensureRename="renameItem"
                         @ensureUpdate="updateItem"
                         @ensureDelete="deleteItem"></file-item>
            </div>
          </div>
          <div class="blankslate" v-else>
            <p>该分类下暂时没有"{{ typeText }}"</p>
          </div>
          <paginator :perPageChangeable='false'
                     resourceUrl='/admin/material/files'
                     :additionalParams='paginatorAdditionalParams'
                     ref='paginatorRef'
                     @dataReceived='dataReceivedFunc'></paginator>
        </template>
        <template v-if="view == 'Folder'">
          <div class="material-files" v-if="folders.length">
            <div class="file"
                 v-for="folder in folders"
                 :key="folder.id">
              <file-item :item='folder'
                         :editable="editable"
                         :view="view"
                         @selectFolder="selectGroupFunc"
                         @ensureRename="renameFolder"
                         @ensureDelete="deleteFolder"></file-item>
            </div>
          </div>
          <div class="blankslate" v-else>
            <p>该分组下暂时没有分类</p>
          </div>
        </template>
      </div>
  </div>
</div>`,
  data: function() {
    return {
      material_files: [],
      nav_folder: [],
      currentGroup: {},
      currentFolder: {},
      targetGroup: {},
      uploading: false,
      view: ''
    };
  },
  created: function() {
    return Skylark.Libs.Ajax.get('/admin/material/folders.json', {
      responseType: 'json',
      success: (data, xhr) => {
        var ownedGroup, ownedUngrouped, sharedGroup, sharedUngrouped;
        sharedUngrouped = _.extend({
          id: null,
          name: '未分组',
          shared: true
        }, data.shared.ungrouped, {
          children_count: null
        });
        ownedUngrouped = _.extend({
          id: null,
          name: '未分组',
          shared: false
        }, data.owned.ungrouped, {
          children_count: null
        });
        _.each(['shared', 'owned'], function(name) {
          return _.each(data[`${name}`].folders, function(folder) {
            return _.extend(folder, {
              expanded: false
            });
          });
        });
        sharedGroup = {
          name: '共享文件',
          id: null,
          type: 'shared',
          expanded: false,
          shared: true,
          navs: [sharedUngrouped].concat(data.shared.folders)
        };
        ownedGroup = {
          name: '我的文件',
          id: null,
          type: 'owned',
          shared: false,
          expanded: true,
          navs: [ownedUngrouped].concat(data.owned.folders)
        };
        this.nav_folder = [sharedGroup, ownedGroup];
        this.totalSize = data.total_size;
        if (this.editable) {
          this.currentFolder = ownedGroup;
          return this.view = 'Folder';
        } else {
          this.currentGroup = ownedUngrouped;
          return this.view = 'Group';
        }
      }
    });
  },
  computed: {
    paginatorAdditionalParams: function() {
      return {
        folder_id: this.currentGroup.id,
        shared: this.currentGroup.shared,
        type: this.materialType
      };
    },
    typeText: function() {
      return Skylark.Helpers.getZH_CN(`material.type.${this.materialType}`);
    },
    folders: function() {
      if (this.currentFolder.children) {
        return this.currentFolder.children;
      } else {
        return this.currentFolder.navs || [];
      }
    },
    acceptType: function() {
      if (this.materialType === 'material') {
        return 'image/*,video/*';
      } else {
        return this.materialType + '/*';
      }
    }
  },
  watch: {
    currentGroup: function(newValue) {
      if (newValue) {
        return this.$nextTick(function() {
          var ref;
          return (ref = this.$refs.paginatorRef) != null ? ref.go(1) : void 0;
        });
      }
    },
    totalSize: function() {
      return this.$emit('totalSizeChanged', this.totalSize);
    },
    view: function() {
      return this.$emit('clearSelected');
    }
  },
  methods: {
    _materialCounts: function(group) {
      var counts;
      if (this.materialType === 'material') {
        counts = 0;
        _.each(this.typeList, function(type) {
          if (type.value === 'material') {
            return;
          }
          return counts += group[`${type.value}s_count`] || 0;
        });
        return counts;
      } else {
        return group[`${this.materialType}s_count`] || 0;
      }
    },
    _childrenMaterialCounts: function(group) {
      var childrenMaterialCounts;
      childrenMaterialCounts = 0;
      if (group.children_count) {
        _.each(group.children, (item) => {
          return childrenMaterialCounts += this._materialCounts(item);
        });
      } else {
        childrenMaterialCounts = this._materialCounts(group);
      }
      return childrenMaterialCounts;
    },
    dataReceivedFunc: function(data) {
      return this.material_files = new Skylark.Libs.Storage.Attachments(data).files;
    },
    selectGroupFunc: function(group) {
      if (group.children || group.navs) {
        if (!this.editable) {
          return;
        }
        if (group.children && this.currentFolder.navs) {
          this.currentFolder.expanded = true;
        }
        this.currentFolder = group;
        return this.view = 'Folder';
      } else {
        this.currentFolder.expanded = true;
        this.currentGroup = group;
        return this.view = 'Group';
      }
    },
    targetGroupFunc: function(group) {
      if (group.children || group.navs) {
        return;
      }
      return this.targetGroup = group;
    },
    addMaterials: function(event) {
      var options;
      options = {
        custom_variables: {
          folder_id: this.currentGroup.id,
          shared: this.currentGroup.shared
        },
        uptokenUrl: '/admin/material/files/uptoken.json',
        createUrl: '/admin/material/files.json',
        success: (current_file) => {
          this.currentGroup[`${current_file.extension}s_count`] += 1;
          return this.totalSize += current_file.size;
        }
      };
      if (this.materialType !== 'image') {
        options.limitSize = 5 * 1024 * 1024 * 1024 * 1024;
      }
      this._prepAttachments = new Skylark.Libs.Storage.Attachments(event.target.files, options);
      this.material_files.splice.apply(this.material_files, [0, 0].concat(this._prepAttachments.files));
      this.material_files = this.material_files.slice(0, this.$refs.paginatorRef.perPage);
      this.uploading = true;
      return this._prepAttachments.upload({
        uploadCompleted: () => {
          event.target.value = null;
          this._prepAttachments = null;
          return this.uploading = false;
        }
      });
    },
    reloadAttachment: function(index) {
      var material;
      material = this.material_files[index];
      material._error_message = '';
      this.uploading = true;
      return material.upload({
        error: function(error, xhr) {
          return material._error_message = error.message;
        },
        progress: function(error, percentage) {
          return material._progress = percentage;
        },
        complete: () => {
          this.uploading = false;
          return material._progress = 0;
        }
      });
    },
    toggleMaterial: function(event, material, index) {
      if (!material.download_url) {
        return;
      }
      if (event.shiftKey && this.multiple) {
        return this.toggleMultiMaterials(index);
      } else {
        this.firstClickIndex = index;
        return this.$emit('toggleMaterial', material);
      }
    },
    toggleMultiMaterials: function(lastIndex) {
      var selectMaterials;
      if (!_.isNumber(this.firstClickIndex)) {
        return;
      }
      selectMaterials = this.firstClickIndex > lastIndex ? this.material_files.slice(lastIndex, this.firstClickIndex + 1) : this.material_files.slice(this.firstClickIndex, lastIndex + 1);
      return this.$emit('toggleMultiMaterials', selectMaterials);
    },
    selectAll: function() {
      if (this.selectMaterials === this.material_files) {
        return this.$emit('clearSelected');
      } else {
        return this.$emit('selectAll', this.material_files);
      }
    },
    cancelClicked: function(name) {
      return this.$refs[`popover_${name}`].togglePopover();
    },
    deleteSelected: function() {
      return this.$emit('deleteSelected');
    },
    moveMaterials: function() {
      return this.$emit('moveMaterials', this.targetGroup);
    },
    refresh: function() {
      return this.$refs.paginatorRef.refresh();
    },
    typeChanged: function(option) {
      if (this.materialType === option.value) {
        return;
      }
      return this.$emit('typeChanged', option.value);
    },
    updateMaterials: function() {
      return this.$nextTick(function() {
        return this.$refs.paginatorRef.doRequest();
      });
    },
    updateItem: function(material, event) {
      var options;
      options = {
        uptokenUrl: `/admin/material/files/${material.id}/update_uptoken`,
        createUrl: `/admin/material/files/${material.id}/update_info.json`
      };
      if (this.materialType !== 'image') {
        options.limitSize = 5 * 1024 * 1024 * 1024 * 1024;
      }
      material = new Skylark.Libs.Storage.Attachment(event.target.files[0], options);
      this.uploading = true;
      return material.upload({
        success: () => {
          return this.$nextTick(function() {
            return this.$refs.paginatorRef.refresh();
          });
        },
        complete: () => {
          event.target.value = null;
          return this.uploading = false;
        }
      });
    },
    renameItem: function(material, name) {
      var file;
      file = {
        material_file: {
          name: name
        }
      };
      return Skylark.Libs.Ajax.patch(`/admin/material/files/${material.id}`, {
        data: file,
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          return _.extend(_.find(this.material_files, function(file) {
            return file.id === data.id;
          }), data);
        }
      });
    },
    deleteItem: function(material) {
      return this.$emit('deleteSelected', material);
    },
    updateCounts: function(changedCounts, group) {
      return _.each(changedCounts, (value, key) => {
        if (group) {
          return group[key] -= value;
        } else {
          return this.currentGroup[key] += value;
        }
      });
    },
    addFolder: function(listItem, groupName) {
      var folder;
      folder = {
        material_folder: {
          name: '未命名',
          parent_id: this.currentFolder.id,
          shared: this.currentFolder.shared
        }
      };
      return Skylark.Libs.Ajax({
        url: '/admin/material/folders',
        method: 'POST',
        data: folder,
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data) => {
          if (this.currentFolder.navs) {
            return this.currentFolder.navs.push(_.extend(data, {
              children: [],
              show_edit_input: false
            }));
          } else {
            return this.currentFolder.children.push(data);
          }
        }
      });
    },
    renameFolder: function(folder, name) {
      var group;
      group = {
        material_folder: {
          name: name
        }
      };
      return Skylark.Libs.Ajax.patch(`/admin/material/folders/${folder.id}`, {
        data: group,
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          return _.extend(_.find(this.folders, function(folder) {
            return folder.id === data.id;
          }), data);
        }
      });
    },
    deleteFolder: function(child) {
      var parent;
      parent = this.currentFolder.children ? this.currentFolder.children : this.currentFolder.navs;
      parent.splice(_.indexOf(parent, child), 1);
      return Skylark.Libs.Ajax.delete(`/admin/material/folders/${child.id}`, {
        success: () => {
          return newAlertify('删除分类成功', {
            type: 'success',
            showIcon: true
          });
        },
        error: () => {
          return newAlertify('删除分类失败', {
            type: 'error',
            showIcon: true
          });
        }
      });
    }
  }
});
